import { Avatar, Button, Grid, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import AppHeader from '../components/AppHeader';
import { appRoutes } from "../AppRoutes";
import BodyContainer from "../components/BodyContainer";
import { Box } from "@mui/system";

const Home = () => {
	return (
		<>
			{/* <AppHeader /> */}
			<BodyContainer hasHeader={false}>
				<Grid item xs={4} sm={1} width="100%" sx={{display:'flex'}}>
					<Box
					component="img"
					sx={{display: 'flex', width: 'auto', height: 'auto', maxWidth:'200px', margin: 'auto'}}
					alt="fire-smart-logo"
					src="/fire-smart-logo.png"/>
				</Grid>
				<Grid item xs={6} sm={9} mt={12} width="100%">
					<Typography variant="welcome" align="center" component="h1" mb={2}>
						Welcome to the <br />
						Arkansas Forestry and Row Crop Prescribed Fire App
					</Typography>
				</Grid>
				<Grid item xs={1} sm={2} mb={2} width="100%" display="flex" alignItems="center">
					<Button
						fullWidth
						variant="contained"
						size="large"
						component={Link}
						to={appRoutes.SelectLocation}
						color="primary">
						Submit a Burn
					</Button>
				</Grid>
			</BodyContainer>
		</>
	)
}

export default Home;